import { RevealBlock } from "./motion";

const HIGHLIGHTS = [
  { n: "Melbourne", l: "Founded in Australia" },
  { n: "2 pharmacists", l: "Founder-led operation" },
  { n: "24 / 7",    l: "Always available" },
  { n: "Managed",   l: "End-to-end service" },
];

export default function About() {
  const smoothTo = (id) => document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="about" className="relative bg-ink py-16 md:py-24 border-t border-white/8" data-testid="about-section">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10 grid grid-cols-12 gap-8 md:gap-12 items-start">
        <div className="col-span-12 lg:col-span-5">
          <RevealBlock>
            <p className="eyebrow mb-3">About MinisRus</p>
            <h2 className="font-display font-light text-bone text-3xl sm:text-4xl md:text-5xl leading-[1.05] tracking-tight">
              A thoughtful take on<br /><span className="text-orange">automated retail.</span>
            </h2>
            <div className="mt-5 gold-rule" />
          </RevealBlock>

          <div className="mt-10 grid grid-cols-2 gap-px bg-white/8 border border-white/8 rounded-xl overflow-hidden">
            {HIGHLIGHTS.map((s, i) => (
              <RevealBlock key={s.l} delay={0.05 * i} className="bg-ink p-5 md:p-6" data-testid={`about-stat-${i}`}>
                <p className="font-display text-xl md:text-2xl text-orange leading-none">{s.n}</p>
                <p className="mt-2 text-bone/65 text-xs md:text-sm">{s.l}</p>
              </RevealBlock>
            ))}
          </div>
        </div>

        <div className="col-span-12 lg:col-span-7">
          <RevealBlock className="space-y-5 font-sans">
            <p className="text-bone/85 text-base md:text-lg leading-relaxed">
              MinisRus was founded and is operated in Melbourne by two pharmacists with healthcare retail experience and a shared interest in improving access to everyday personal-care products.
            </p>
            <p className="text-bone/75 text-base md:text-lg leading-relaxed">
              The idea began with a simple observation: people often need skincare, hygiene, wellness and travel-size products when traditional retail is closed, inconvenient or unavailable nearby.
            </p>
            <p className="text-bone/75 text-base md:text-lg leading-relaxed">
              We created MinisRus to bring a more thoughtful form of automated retail into high-traffic environments. Our aim is to combine trusted product categories, modern technology and a premium customer experience in a compact, fully managed format.
            </p>
            <p className="text-orange text-base md:text-lg leading-relaxed font-medium pt-2">
              We are currently accepting enquiries for our first fully managed locations across Australia.
            </p>
          </RevealBlock>

          <RevealBlock delay={0.15}>
            <button
              onClick={() => smoothTo('#enquiries')}
              className="group mt-8 inline-flex items-center gap-2 h-12 px-7 bg-orange text-ink hover:bg-orange-soft rounded-full text-[13px] font-semibold transition-colors"
              data-testid="about-cta-btn"
            >
              Get in touch
              <span className="inline-block transition-transform group-hover:translate-x-1">→</span>
            </button>
          </RevealBlock>
        </div>
      </div>
    </section>
  );
}
